import getListRoutes from '@/src/getListRoutes'
import queryString from 'query-string'

type Args = {
  route: string
  values?: Record<string, string>
  argsObject?: Record<string, unknown>
}

type Output = {
  href: string
  as: string
}

const getRoutes = ({ route, values = {}, argsObject = null }: Args): Output => {
  const routeSelect = getListRoutes.find(
    oneRoute => oneRoute.route === route || (!route && oneRoute.route === 'Home')
  )

  const { href, queryArgsForce } = routeSelect || { href: '', queryArgsForce: {} }

  const parseArgs = { ...queryArgsForce, ...argsObject }
  const urlLocalised = `/[locale]${href}${Object.keys(parseArgs).length ? `?${queryString.stringify(parseArgs)}` : ''}`

  let as = urlLocalised.replace('[locale]', currentLocale)

  !!values &&
    Object.keys(values).forEach(key => {
      as = as.replace(key, values[key])
    })

  return { as, href: urlLocalised }
}

export default getRoutes
